import { render } from "./slidesQuestion.vue?vue&type=template&id=79072a3e&scoped=true"
import script from "./slidesQuestion.vue?vue&type=script&lang=js"
export * from "./slidesQuestion.vue?vue&type=script&lang=js"

import "./slidesQuestion.vue?vue&type=style&index=0&id=79072a3e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79072a3e"]])

export default __exports__